import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { SearchAddress } from 'src/app/models/address-search.model';
import * as _ from 'lodash';
import { CountryService } from 'src/app/services/country.service';
import { Countries, Country } from 'src/app/models/settings/countries.model';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-edit-address-dialog',
  templateUrl: './edit-address-dialog.component.html',
  styleUrls: ['./edit-address-dialog.component.scss']
})
export class EditAddressDialogComponent implements OnInit {
  public defaultCountryId: string = '';
  public value: SearchAddress = new SearchAddress();
  public countries: Array<string> = [];

  constructor(
    private countryService: CountryService,
    private sessionService: SessionService,
    private dialogRef: DialogRef) {
    }

  ngOnInit(): void {
    this.loadCountries();
  }

  public onOkClick(): void {
    this.dialogRef.close(this.value);
  }

  public onCancelClick(): void {
    this.dialogRef.close();
  }

  private loadCountries(): void {
    this.sessionService.showLoading();

    this.countryService.getCountries().subscribe({
      next: (result) => this.loadCountriesOk(result),
      error: (error) => this.loadCountriesError(error.error)
    });
  }

  private loadCountriesOk(result: Countries): void {
    if (!_.isNil(result?.countries)) {
      this.countries = _.orderBy(_.map(result.countries, (country) => country.countryName));
    }

    if (!_.isNil(this.value?.formattedAddress?.country) && this.value.formattedAddress.country !== '' && !_.some(this.countries, this.value.formattedAddress.country)) {
      this.countries.push(this.value.formattedAddress.country);
    }

    if (!_.isNil(this.value?.formattedAddress) && !_.isNil(this.defaultCountryId) && this.defaultCountryId !== '' &&
      (_.isNil(this.value?.formattedAddress?.country) || this.value.formattedAddress.country == '')) {
      const defaultCountry = _.find(result.countries, (x: Country) => x.countryId === this.defaultCountryId);

      if (!_.isNil(defaultCountry)) {
        this.value.formattedAddress.country = defaultCountry.countryName;
      }
    }

    this.sessionService.hideLoading();
  }

  private loadCountriesError(error: any): void {
    this.sessionService.hideLoading();
    this.sessionService.showErrorDialog('Error loading country list.');
  }
}
